import { UpdateCartError } from "@dineout-cart-client/hooks/usePerformUpdateCart";
import { IDineoutLocalCart as ILocalCart } from "@swiggy-private/checkout-core";
import { CouponMessageCard } from "@swiggy-private/core-ui";
import React from "react";

export interface UpdateCartContextValue {
    updateCartError?: UpdateCartError | undefined;
    couponModalData: CouponMessageCard | null;
    showPopup?: boolean;
    syncApplyCouponCart: (localCart: ILocalCart) => void;
    onCloseModal: () => void;
    doUpdateCart: (params: ILocalCart) => Promise<void>
    updateCartLoading: boolean;
}

export const UpdateCartContext = React.createContext<UpdateCartContextValue>({
    couponModalData: null,
    showPopup: false,
    syncApplyCouponCart: () => void 0,
    onCloseModal: () => void 0,
    doUpdateCart: () => Promise.resolve(void 0),
    updateCartLoading: false,
    updateCartError: undefined,
});
